import { render, staticRenderFns } from "./ViewsHeader.vue?vue&type=template&id=56c20609&"
import script from "./ViewsHeader.vue?vue&type=script&lang=js&"
export * from "./ViewsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewsHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports